/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import LevelSelectBtn from './LevelSelectBtn';

export default class LevelSelectGroup extends Phaser.GameObjects.Container {
  constructor(scene, nums) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.buttons = [];

    while (this.buttons.length < nums.length) {
      const eggNum = this.buttons.length + 1 > 8 ? (this.buttons.length + 1) - 8 : this.buttons.length + 1;
      const btn = new LevelSelectBtn(this.scene, `egg-${eggNum.toString()}`, nums[this.buttons.length]);
      btn.alpha = 0;
      this.add(btn);
      this.buttons.push(btn);
    }
  }

  showButtons() {
    const spacing = 10;
    const btnWidth = this.buttons[0].getBounds().width;
    const firstWidth = Math.ceil(this.buttons.length / 2) * (this.buttons[0].getBounds().width + spacing) - spacing;
    const secondWidth = Math.floor(this.buttons.length / 2) * (this.buttons[0].getBounds().width + spacing) - spacing;
    const firstX = -(firstWidth / 2) + (btnWidth / 2);
    const secondX = -(secondWidth / 2) + (btnWidth / 2);
    for (let i = 0; i < this.buttons.length; i++) {
      const btn = this.buttons[i];
      if (i < Math.ceil(this.buttons.length / 2)) {
        btn.endX = firstX + (i * (btn.getBounds().width + spacing));
      }
      else {
        btn.endX = secondX + ((i - Math.ceil(this.buttons.length / 2)) * (btn.getBounds().width + spacing));
        btn.y = btn.getBounds().height;
      }

      ABCyaPhaser.Tweens.addTween(btn, 500, { x: btn.endX, alpha: 1 }, Phaser.Math.Easing.Sine.Out);

      btn.on('pointerup', () => {this.selectBtn(btn);});
    }

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_slide_ascend, this.scene);
  };

  hideButtons() {
    for (let i = 0; i < this.buttons.length; i++) {
      const btn = this.buttons[i];
      ABCyaPhaser.Tweens.addTween(btn, 500, { x: 0, alpha: 0 }, Phaser.Math.Easing.Quadratic.In);
      btn.off('pointerup');
      btn.disableInteractive();
    }
  };

  selectBtn(e) {
    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].setSelected(this.buttons[i] === e);
    }

    this.emit('BTN_SELECT', e.btnValue);
  };
}